import withdrawal from "../../../assets/svg/withdrawalSvg.svg";
import svg46 from "../../../assets/svg/svg46.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton } from "antd";
import { useEffect } from "react"; 
import { cashConverter } from "../../../utils";

function WithdrawalHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleWithdraw = () => {
    navigate("/withdrawal-page");
  }; 
    const url = "api/v1/commissions/fetch-commission-dashboard";
    const { loading, data, count } = useSelector((state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
    }));

    
  
  return (
    <div className="report-card  h-auto w-full p-3 mt-3">
      <div className="product_sub !text-[18px]">Available Amount</div>
      <div className="flex items-center justify-between mt-2"> 
        {
          loading ? (
            <Skeleton  paragraph={{ rows: 1, width: '50px' }} />
          ) : (
            <div className="text-[#222222] font-[600] text-[25px]">
             {cashConverter(data?.statusSummary?.Commissioned)}
          </div>
          )
        }

        <div className="w-[230px]">
          <button
            key="submit"
            type="submit"
            className="cstm-btn-2 flex items-center gap-x-2 !rounded-[10px]"
            style={{ boxShadow: "0 4px 0 0 #2A662C" }}
            onClick={handleWithdraw}
          >
            <img src={withdrawal} alt="withdrawal" /> Withdraw Earnings
          </button>
        </div>
      </div>
      <div className="mt-5 bg-[#F5F5F5] p-2 rounded-[8px] flex items-center gap-x-2">
        <img src={svg46} alt="svg46" />
        Earnings update is expected within 30 to 60 min following the users
        purchase of the product
      </div>
    </div>
  );
}

export default WithdrawalHeader;
